// webpacker.ymlのresolved_pathsに指定したプレフィックスは省略可能

// Vue.js
import Vue from "vue/dist/vue.esm";

// /components/surveys
import ConfirmModal from "components/surveys/ConfirmModal.vue";
import TextArea from "components/surveys/TextArea.vue";
import TextBox from "components/surveys/TextBox.vue";
import NumericBox from "components/surveys/NumericBox.vue";

export default new Vue({
  el: "#vue-app",
  components: {
    ConfirmModal,
    TextArea,
    TextBox,
    NumericBox
  },
  created() {
    if (document.getElementsByClassName("field_with_errors")[0] !== null) {
      $(".field_with_errors #terms_of_service_field").unwrap();
    }
  },
  methods: {
    openModal(modalId) {
      $(modalId).modal();
    }
  }
});
